// GSAP -------------------------------------------------------------
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.ScrollTrigger = ScrollTrigger;

window.gsap = gsap;

// ABOUT VIDEO FIELD
let aboutVideoField = $(".about-video-field");
if (aboutVideoField.length) {
  let aboutCursorTL = gsap.timeline({ repeat: -1 });
  let aboutVideoTimeout;
  let aboutVideoCursor = $(".about-video-field .play-button");
  let aboutVideoFieldVideo = $(".about-video-field video");

  if (aboutVideoCursor.length) {
    aboutCursorTL.to(
      ".about-video-field .play-button .circle",
      { duration: 3, drawSVG: "0%" },
      "same"
    );
    aboutCursorTL.to(
      ".about-video-field .play-button .circle",
      { duration: 3, stroke: "#F19620" },
      "same"
    );
    aboutCursorTL.to(
      ".about-video-field .play-button .circle",
      { duration: 3, drawSVG: "-100%" },
      "same-2"
    );
    aboutCursorTL.to(
      ".about-video-field .play-button .circle",
      { duration: 3, stroke: "#FFFFFF" },
      "same-2"
    );
  }

  aboutVideoField
    .mouseover(function () {
      if (aboutVideoCursor.length)
        gsap.to(aboutVideoCursor, 0.25, { scale: 1, autoAlpha: 1 });
      if (aboutVideoFieldVideo.length) {
        clearTimeout(aboutVideoTimeout);
        aboutVideoFieldVideo.fadeIn(300);
        aboutVideoFieldVideo.trigger("play");
      }
    })
    .mouseleave(function () {
      if (aboutVideoCursor.length)
        gsap.to(aboutVideoCursor, 0.25, { scale: 0, autoAlpha: 0 });
      if (aboutVideoFieldVideo.length) {
        clearTimeout(aboutVideoTimeout);
        aboutVideoFieldVideo.fadeOut(300);
        aboutVideoFieldVideo.trigger("stop");
        aboutVideoTimeout = setTimeout(() => {
          aboutVideoFieldVideo[0].currentTime = 0;
        }, 300);
      }
    })
    .mousemove(function (e) {
      if (aboutVideoCursor.length)
        gsap.to(aboutVideoCursor, 0.25, {
          left: e.pageX - $(this).offset().left,
          top: e.pageY - $(this).offset().top,
        });
    });

  // Cursor
  // EĞER HTML dir="rtl" İSE
  if ($("html").attr("dir") == "rtl") {
    $(".about-video-field .video-field")
      .mouseenter(function () {
        let element = $(this).find(".cursor-play");
        gsap.to(element, 0.25, { scale: 1, autoAlpha: 1 });
      })
      .mousemove(function (e) {
        let element = $(this).find(".cursor-play");
        gsap.to(element, 0.25, {
          right: e.pageX - $(this).offset().left,
          top: e.pageY - $(this).offset().top,
        });
      })
      .mouseleave(function () {
        let element = $(this).find(".cursor-play");
        gsap.to(element, 0.25, { scale: 0, autoAlpha: 0 });
      });
  } else {
    $(".about-video-field .video-field")
      .mouseenter(function () {
        let element = $(this).find(".cursor-play");
        gsap.to(element, 0.25, { scale: 1, autoAlpha: 1 });
      })
      .mousemove(function (e) {
        let element = $(this).find(".cursor-play");
        gsap.to(element, 0.25, {
          left: e.pageX - $(this).offset().left,
          top: e.pageY - $(this).offset().top,
        });
      })
      .mouseleave(function () {
        let element = $(this).find(".cursor-play");
        gsap.to(element, 0.25, { scale: 0, autoAlpha: 0 });
      });
  }
}

// HOMEPAGE - CAROUSEL FIELD
let subMenu = $(
  ".homepage-carousel-field .wrapper .carousel-field .carousel-images .content ul"
);
subMenu.on("mousemove", function (e) {
  let wrapperHeight =
    $(this).closest(".content").height() - $(".header-field").height() - 60;
  let height = $(this)[0].scrollHeight;
  let sideHeight = ($(window).height() - wrapperHeight) / 2;
  let difference = (e.pageY - sideHeight) / wrapperHeight;
  let calc = (height - wrapperHeight) * difference;

  gsap.to($(this), { scrollTo: { y: calc }, duration: 2 });
});

// HOMEPAGE - ORDER FIELD
// 1200px'den büyükse
if (windowWidth > 1200) {
  let orderMenu = $(
    ".homepage-order-field .carousel-pagination-field .content ul"
  );
  orderMenu.on("mousemove", function (e) {
    let wrapperHeight =
      $(this).closest(".content").innerHeight() - $(".header-field").height();
    let height = $(this)[0].scrollHeight;
    let difference =
      (e.pageY - $(this).closest(".content").offset().top) / wrapperHeight;
    let calc = (height - wrapperHeight) * difference;

    gsap.to($(this), { scrollTo: { y: calc }, duration: 1, ease: "none" });
  });
}else{
    // mobilde scroll alanı (safaride overflow-x: scroll sorunlu çalıştığı için js ile yapılıyor.)
    let orderMenu = $(".homepage-order-field .carousel-pagination-field .content ul");
    let startX = 0;
    let scrollLeft = 0;

    orderMenu.on('touchstart', function(e) {
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = $(this).scrollLeft();
    });

    orderMenu.on('touchmove', function(e) {
        e.preventDefault();
        const x = e.originalEvent.touches[0].pageX;
        const walk = (x - startX) * 1; 
        $(this).scrollLeft(scrollLeft - walk);
    });
}
